export enum ElementState {
  WithoutElement = 0,
  NewElement = 1,
  ExistingElement = 2
}
